// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jg-6";
export var emphasizeQuantity = "_jg-3";
export var flatBottomCorners = "_jg-5";
export var productImage = "_jg-0";
export var quantityContainer = "_jg-2";
export var tooltip = "_jg-1";
export var wrapAndEllipsesOverflow = "_jg-4";